import CopyrightIcon from '@material-ui/icons/Copyright';
import React, { useState } from 'react';
import { apiUrls } from '../../constants/apiUrls';
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { FooterStyles } from '../styles/footer';
import { getCookie } from '../../common/utils/cookies';
import { ICPRecordalStyles } from '../styles/utilityLinks';
import { supportUrls } from '../../constants/supportUrls';
import { useBasicDetails } from '../../store/storeApi';
import { useTranslation } from 'react-i18next';
import { UtilityLink } from '../../common/components/UtilityLink';
import { getLinksJSX } from './SHLEHeader';
import { isArabicLocale } from '../../common/utils/checkLocalePlayer';
import { TemplateLayout } from '../../store/interfaces/template';

/** Footer Component */
const Footer = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    template: {
      settings: { footer, links, page },
      layoutCode,
    },
    headerDetails,
  } = useBasicDetails();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const classes = FooterStyles(footer);
  const icpRecordalClass = ICPRecordalStyles(page);

  /** Need to add logic for showing the ICP Record */
  const [isICPRecord] = useState({
    label: t('icpRecordal'),
    url: apiUrls.ICP_RECORDAL_CHINA,
  });

  const handleHelp = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    const locale = getCookie('locale_player') || 'en_US';
    const language = supportUrls[locale.toLowerCase()] || 'en_US';
    const link = `https://support.shl.com/candidate?l=${language}&c=SHL_Support%3ACandidate_Help&p=&pt=&lg=&cg=`;
    window.open(link, '_blank');
  };

  return (
    <>
      {headerDetails.isICPEnabled && (
        <Box className="icp-recordal-footer" position="relative">
          <Box
            position="absolute"
            title={isICPRecord.label}
            aria-label={isICPRecord.label}
            className={icpRecordalClass.container}>
            <UtilityLink link={isICPRecord} classes={icpRecordalClass} />
          </Box>
        </Box>
      )}

      <footer
        className={`${classes.footer} ${
          layoutCode === TemplateLayout.TEMPLATE_LAYOUT_02 ? ` ${classes.journeyTheme}` : ''
        }`}>
        <Grid container>
          <Grid item xs={12} lg={8}>
            {links && (
              <Box
                display="flex"
                flexWrap="wrap"
                justifyContent={lgUp ? 'flex-start' : 'center'}
                component="ul"
                className={classes.utilityLink}>
                {getLinksJSX(links)}
              </Box>
            )}
            <Box display="flex" justifyContent={lgUp ? 'flex-start' : 'center'} alignItems="center">
              {isArabicLocale() ? (
                <Typography variant="subtitle2" className={classes.copyRightText} dir="ltr">
                  {` ${new Date().getFullYear()} `}
                  {t('allRightsReserved')}
                  <CopyrightIcon />
                </Typography>
              ) : (
                <Typography variant="subtitle2" className={classes.copyRightText}>
                  <CopyrightIcon />
                  {` ${new Date().getFullYear()} `}
                  {t('allRightsReserved')}
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} lg={4}>
            <Box
              display="flex"
              alignItems="center"
              mt={lgUp ? '28px' : 0}
              mb={lgUp ? '28px' : 0}
              justifyContent={lgUp ? 'flex-end' : 'center'}>
              <Button variant="outlined" className={classes.footerButton} onClick={handleHelp}>
                <div>{footer.helpButton.text}</div>
              </Button>
            </Box>
          </Grid>
        </Grid>
      </footer>
    </>
  );
};

export default Footer;
